import { createFileRoute } from "@tanstack/react-router";

import PurchaseLayout from "./-components/Purchase/PurchaseLayout";

export const Route = createFileRoute("/_authenticated/trade/purchase")({
  component: PurchaseLayout,
  context: () => ({ permissions: "trade.purchase" }),
});
